import {
  Companion_getInstance95jshvyfe4f5 as Companion_getInstance,
  ClientFeedback208nr9qsd3d5f as ClientFeedback,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareClientFeedbackFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ClientFeedback_at_getInstance(), ClientFeedback_message_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function ClientFeedback_at$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ClientFeedback_at$_get_name_$ref_oa2x0x() {
  return (p0) => p0.i20();
}
function ClientFeedback_at$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ClientFeedback_at$_get_serializer_$ref_zhazm2() {
  return (p0) => p0.h2j();
}
function ClientFeedback_at$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ClientFeedback_at$_get_annotations_$ref_ic2rui() {
  return (p0) => p0.bz();
}
var ClientFeedback_atClass;
function ClientFeedback_at() {
  if (ClientFeedback_atClass === VOID) {
    class $ {
      constructor() {
        ClientFeedback_at_instance = this;
        var tmp = this;
        tmp.g5b_1 = lazy(ClientFeedback_at$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h5b_1 = lazy(ClientFeedback_at$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i5b_1 = lazy(ClientFeedback_at$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.j5b_1 = get_default(Companion_instance).b1m();
        this.k5b_1 = 'now()';
      }
      i20() {
        var tmp0 = this.g5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ClientFeedback_at$_get_name_$ref_oa2x0x(), null);
        return tmp0.f2();
      }
      l5b(receiver) {
        return receiver.m5b_1;
      }
      k2j(receiver) {
        return this.l5b(receiver instanceof ClientFeedback() ? receiver : THROW_CCE());
      }
      o5b(receiver, value) {
        return receiver.p5b(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ClientFeedback() ? receiver : THROW_CCE();
        return this.o5b(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ClientFeedback_at$_get_serializer_$ref_zhazm2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ClientFeedback_at$_get_annotations_$ref_ic2rui(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ClientFeedback_at', VOID, VOID, [SerializableProperty()]);
    ClientFeedback_atClass = $;
  }
  return ClientFeedback_atClass;
}
var ClientFeedback_at_instance;
function ClientFeedback_at_getInstance() {
  if (ClientFeedback_at_instance === VOID)
    new (ClientFeedback_at())();
  return ClientFeedback_at_instance;
}
function ClientFeedback_message$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ClientFeedback_message$_get_name_$ref_8wrie3() {
  return (p0) => p0.i20();
}
function ClientFeedback_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ClientFeedback_message$_get_serializer_$ref_tud2lw() {
  return (p0) => p0.h2j();
}
function ClientFeedback_message$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ClientFeedback_message$_get_annotations_$ref_ecwjcg() {
  return (p0) => p0.bz();
}
var ClientFeedback_messageClass;
function ClientFeedback_message() {
  if (ClientFeedback_messageClass === VOID) {
    class $ {
      constructor() {
        ClientFeedback_message_instance = this;
        var tmp = this;
        tmp.q5b_1 = lazy(ClientFeedback_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r5b_1 = lazy(ClientFeedback_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s5b_1 = lazy(ClientFeedback_message$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.q5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ClientFeedback_message$_get_name_$ref_8wrie3(), null);
        return tmp0.f2();
      }
      l5b(receiver) {
        return receiver.n5b_1;
      }
      k2j(receiver) {
        return this.l5b(receiver instanceof ClientFeedback() ? receiver : THROW_CCE());
      }
      t5b(receiver, value) {
        return receiver.p5b(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ClientFeedback() ? receiver : THROW_CCE();
        return this.t5b(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ClientFeedback_message$_get_serializer_$ref_tud2lw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s5b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ClientFeedback_message$_get_annotations_$ref_ecwjcg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ClientFeedback_message', VOID, VOID, [SerializableProperty()]);
    ClientFeedback_messageClass = $;
  }
  return ClientFeedback_messageClass;
}
var ClientFeedback_message_instance;
function ClientFeedback_message_getInstance() {
  if (ClientFeedback_message_instance === VOID)
    new (ClientFeedback_message())();
  return ClientFeedback_message_instance;
}
//region block: exports
export {
  prepareClientFeedbackFields as prepareClientFeedbackFieldsm5trhzd2yxmc,
};
//endregion

//# sourceMappingURL=ClientFeedbackFields.mjs.map
